<template>
    <div class="card_container">
        <img src="@/assets/offers/deposit_promotions_card.png" alt="">
        <van-row class="card_data">
            <van-col span="7" offset="3">
                <div class="title_text">{{ $t('common.deposite') }} <span>R${{ Number(props.cardData.recharge)
                }}</span></div>
                <div class="title_text">{{ $t('offers.win') }} <span>R$ {{ Number(props.cardData.reward) }}</span>
                </div>
            </van-col>
            <van-col span="7" class="right_cell">
                <div class="right_text"><span>{{ Number(props.cardData.recharge) +
                    Number(props.cardData.reward) }}</span></div>
                <div class="right_text">{{ $t('offers.totaling') }}(R$)</div>
            </van-col>
            <van-col span="7" class="deposit_btn">
                <van-button size="small" @click="handleDeposit">{{ $t('common.deposite') }}</van-button>
            </van-col>
            <van-col span="24" class="bottom_text">
                <div class="right_text">{{ $t('offers.demanding') }} R$ {{ Number(props.cardData.turnover) }} {{
                    $t('offers.rollover') }}</div>
            </van-col>
        </van-row>
    </div>
    <InfoPoup ref="infoPopupRef" />
    <DepositPopup ref="depositpopupRef" />
</template>
<script setup lang="ts">
import { ref, defineProps } from 'vue';
import InfoPoup from './infoPoup.vue';
import DepositPopup from './depositPopup.vue';

const infoPopupRef = ref()
const depositpopupRef = ref()
const props = defineProps({
    cardData: {
        type: Object,
        required: true
    },
    isActivityEnable: {
        type: Boolean,
        default: false
    },
    dayName: {
        type: String,
    }
})
const handleDeposit = () => {
    if (props.isActivityEnable) {
        depositpopupRef.value.open(props.cardData)
    } else {
        infoPopupRef.value.open(props.dayName)
    }
}
</script>
<style scoped>
.card_container img {
    width: 100%;
    margin-bottom: 2vw;
    display: block;
}

.card_container {
    position: relative;
    width: 100%;
}

.card_data {
    position: absolute;
    top: 10px;
    left: 0;
    bottom: 5px;
    width: 100%;
    color: rgba(255, 255, 255, 0.65);
}

.title_text {
    font-size: 11px;
    padding: 2.5px;
}

.title_text span {
    color: #fff;
}

.right_cell {
    text-align: right;
}

.right_text {
    font-size: 10px;
}

.right_text span {
    font-size: 16px;
    color: #FFEE00;
}
.deposit_btn{
    display: flex;
    justify-content: center;
}

.deposit_btn>>>.van-button--small {
    border: none;
    color: #12151A;
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    border-radius: 20px;
    width: 75%;
    margin-left: 10px;
    margin-top: 5px;
    font-size: 10px !important;
}

.bottom_text {
    padding-left: 10px;
    display: flex;
    align-items: end;
    padding-bottom: 1%;
}

@media (min-width: 400px) {
    .bottom_text {
        /* margin-top: 28px !important; */
    }

    .title_text {
        font-size: 13px;
    }

    .right_text {
        font-size: 12px;
    }

    .right_text span {
        font-size: 18px;
    }

    .card_container img {
        margin-bottom: 10px !important;
    }
    .deposit_btn>>>.van-button--small {
    font-size: 12px !important;
}
}
</style>